import { MouseEventHandler } from 'react';
import { Col } from 'react-bootstrap';
import { IoMdNotifications } from 'react-icons/io';
import IconWrapper from '../IconWrapper';

interface NotificationIconProps {
  unreadNotification: number;
  onClick: MouseEventHandler<HTMLDivElement>;
}

const NotificationIcon = ({ unreadNotification, onClick }: NotificationIconProps) => {
  return (
    <Col xs="auto" className="icons-container cursor-pointer" onClick={onClick}>
      <IconWrapper size={25} rotate>
        <IoMdNotifications />
      </IconWrapper>
      {unreadNotification === 0 ? null : (
        <div className="notification-badge">
          <span className="text-white">{unreadNotification}</span>
        </div>
      )}
    </Col>
  );
};

export default NotificationIcon;
